import Permissions from './Permissions';

export default function () {
  return {
    clients: {
      phone: [Permissions.CLIENT_READ_CONTACT_IN_LIST],
      mobile: [Permissions.CLIENT_READ_CONTACT_IN_LIST],
      email: [Permissions.CLIENT_READ_CONTACT_IN_LIST],
      email2: [Permissions.CLIENT_READ_CONTACT_IN_LIST],
      companyClient: ['DISABLED'],
      client2UserLoggers: ['DISABLED'],
      active: ['DISABLED'],
    },
    users: {},
    affiliates: {},
    smtps: {},
    whitelists: {},
    mailTemplates: {},
    monetaries: {},
    kyc: {},
    symbol: {},
    symbolGroup: {},
    closedTrades: {},
    trades: {},
    clientStatus: {},
    psp: {},
    userActivity: {},
  };
}
